<template>
    <div class="el-table-container templateBox">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1,1,1)" label-width="80px">
            <el-form-item label="关键字：" prop="keyword">
                <el-input v-model.trim="searchForm.keyword" maxlength="20"
                          placeholder="请输入关键字(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="关联元数据模板：" label-width="130px" prop="metaId">
                <el-select v-model="searchForm.metaId" style="width: 100%" placeholder="请选择关联元数据模板" clearable>
                    <el-option
                            v-for="item in metaIdList"
                            :key="item.id"
                            :label="item.basicDataName"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1,1,1)" size="small" icon="el-icon-search">查询
                </el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
            <el-form-item class="f_r">
                <el-button v-show="pageType=='myChart'" v-if="hasPermission(`academic:point:${pageType}:add`)"
                           type="primary" @click="addNode('add')"
                           size="small">新增
                </el-button>
                <el-button v-show="pageType=='myChart'" v-if="hasPermission(`academic:point:${pageType}:import`)"
                           type="primary" @click="importData()"
                           size="small">导入
                </el-button>
                <el-button v-if="hasPermission(`academic:point:${pageType}:export`)" type="primary"
                           @click="exportData()"
                           size="small">导出
                </el-button>
                <el-button v-show="pageType=='myChart'" v-if="hasPermission(`academic:point:${pageType}:deletes`)"
                           type="primary"
                           @click="deleteData()" size="small">删除
                </el-button>
            </el-form-item>
        </el-form>
        <div class="dataBox">
            <el-table
                    :data="dataList"
                    v-loading="loading"
                    size="small" height="100%"
                    class="table" border
                    ref="multipleTable"
                    :row-key="'id'"
                    @sort-change="sortChange"
                    @selection-change="selectionChangeHandle"
            >
                <el-table-column :reserve-selection="true" type="selection" width="50"/>
                <el-table-column prop="knowledgeName" label="知识图谱名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="metaName" label="关联元数据模板" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="pageType=='myChart'" prop="knowledgeState" label="状态"
                                 show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <el-switch
                                v-model="row.knowledgeState"
                                active-value="1"
                                @change="setType(row)"
                                inactive-value="0">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="knowledgeDescribe" label="描述" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="pageType!='myChart'" prop="updateByName" label="最新修改人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="updateDate" label="最新修改时间" sortable show-overflow-tooltip></el-table-column>
                <el-table-column v-if="pageType!='myChart'" prop="createByName" label="创建人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createDate" label="创建时间" sortable show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" v-if="pageType == 'myChart'" width="180px" label="操作">
                    <template slot-scope="{row}">
                        <div class="flex_l_c flex_w">
                            <el-button v-if="hasPermission(`academic:point:${pageType}:detail`)" type="text" size="small"
                                       @click="seeData(row)">详情
                            </el-button>
                            <el-button v-show="pageType=='myChart'" v-if="hasPermission(`academic:point:${pageType}:edit`)"
                                       type="text" size="small"
                                       @click="addNode('edit',row)">编辑
                            </el-button>
                            <el-button v-show="pageType=='myChart'"
                                       v-if="hasPermission(`academic:point:${pageType}:nodeMage`)" type="text" size="small"
                                       @click="nodeMage(row)">节点管理
                            </el-button>
                            <el-button v-show="pageType=='myChart'"
                                       v-if="hasPermission(`academic:point:${pageType}:deletes`)" type="text"
                                       size="small" @click="deleteData(row)">删除
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" v-else width="80px" label="操作">
                    <template slot-scope="{row}">
                        <div class="flex_l_c flex_w">
                            <el-button v-if="hasPermission(`academic:point:${pageType}:detail`)" type="text" size="small"
                                       @click="seeData(row)">详情
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <add-chart ref="addChart" @refresh="refreshList(1,1,1)"></add-chart>
        <detail-chart ref="detailChart"></detail-chart>
        <node-manage-list ref="nodeManageList"></node-manage-list>
        <importDataChart ref="importDataChart" @refreshData="refreshList()"></importDataChart>
    </div>
</template>

<script>
import AddChart from "@/views/modules/academic/point/addChart.vue";
import DetailChart from "@/views/modules/academic/point/detailChart.vue";
import NodeManageList from "@/views/modules/academic/point/nodeManage/nodeManageList.vue";
import importDataChart from "@/views/modules/academic/point/importDataChart.vue";

export default {
    name: "myChart",
    components: {NodeManageList, DetailChart, AddChart,importDataChart},
    props: {
        pageType: {
            type: String,
            default: 'myChart',
        },
    },
    data() {
        return {
            searchForm: {
                keyword: '',
                metaId: '',
                current: 1,
                size: 20,
            },
            total: 0,
            metaIdList: [],

            loading: false,
            dataList: [],
            dataListSelect: [],

            searchData:{},
        }
    },

    mounted() {
        this.refreshList()
        this.$axios(this.api.metadata.selectMetadataBasicDataCleanList, [], 'post').then(data => {
            if (data && data.status) {
                this.metaIdList = data.data
            }
        })
    },

    methods: {
        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect, sort) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            if (sort) {
                this.$refs.multipleTable.clearSort()
            }
            this.loading = true
            let fetchUrl = this.api.academic.knowledgegraphList
            if (this.pageType != 'myChart') {
                fetchUrl = this.api.academic.knowledgegraphOpenList
            }
            this.searchData = this.searchForm
            this.$axios(fetchUrl, this.searchForm).then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },

        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1, 1)
        },

        // 列表排序
        sortChange(column, type) {
            // sort: column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : '')
            console.log(column)
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },

        //切换状态
        setType(row) {
            row.knowledgeState = row.knowledgeState == 1 ? 0 : 1
            this.$axios(this.api.academic.knowledgegraphUpdateById, {
                id: row.id,
                knowledgeState: row.knowledgeState == 1 ? 0 : 1,
            }, 'put').then(data => {
                if (data && data.status) {
                    this.$message.success('状态修改成功')
                    this.refreshList('', 1)
                } else {
                    this.$message.error(data.msg)
                    this.refreshList('', 1)
                }
            })
        },

        //type add新增 edit编辑
        addNode(type, row) {
            this.$refs.addChart.init(type, row)
        },

        //知识图谱详情
        seeData(row) {
            this.$refs.detailChart.init(row)
        },

        //节点管理
        nodeMage(row) {
            this.$refs.nodeManageList.init(row)
        },

        //导入
        importData() {
            this.$refs.importDataChart.init()
        },

        //导出
        exportData() {
            if (this.total == 0) {
                this.$message.warning('暂无可导出的数据!')
                return
            }
            let ids = this.dataListSelect.map(item => {
                return item.id
            })
            let fetchUrl = this.api.academic.knowledgegraphExport
            let fileName = '我的知识图谱模型'
            if (this.pageType != 'myChart'){
                fetchUrl = this.api.academic.knowledgegraphExportCentre
                fileName = '知识图谱模型管理'
            }
            this.exportExcel(fetchUrl, {
                ids,
                ...this.searchData
            }, fileName, 'post')
        },

        //删除
        deleteData(row) {
            let list = row ? [row] : this.dataListSelect
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let statusTrueList = []
            let ids = list.map(item => {
                if (item.knowledgeState == 1) {
                    statusTrueList.push(item)
                }
                return item.id
            })
            if (statusTrueList.length != 0) {
                this.$message.warning('请先禁用后再删除！')
                return
            }
            this.$confirm(`您是否确认删除数据?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.academic.knowledgegraphRemoveById, {ids}, 'delete').then(data => {
                    if (data && data.status) {
                        this.$message.success('删除成功')
                        this.refreshList('', 1)
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
    }
}
</script>

<style scoped>

</style>
